import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Component to provide a UI for creating new entities in an "empty state" scenario.
 * It displays an input field for the user to enter a name and a button to submit the name.
 *
 * @example
 * <app-empty-state-create
 *   *ngIf="show.emptyStateNoModels"
 *   [isAdmin]="isAdmin"
 *   [title]="'Commitment allocation model'"
 *   [description]="labelsText.disclaimer"
 *   [placeholder]="'Model name'"
 *   [iconNameAndStyling]="'prediction-models.svg; icon-size-3p125 black-7'"
 *   (createButtonClick)="onModelNameEmit($event)">
 * </app-empty-state-create>
 *
 * @remarks
 * This component does not currently distinguish user roles such as 'isAdmin'.
 * @input<> isAdmin: boolean – Currently unused, intended for future use to tailor the UI based on user role.
 * @input title: string – The title to display above the input field.
 * @input description: string – A brief description or guidance displayed below the input field.
 * @input placeholder: string – Placeholder text for the input field.
 * @input iconNameAndStyling: string – The icon file name located in '/assets/svg/optimized/',
 * optionally followed by a semicolon and additional CSS classes to apply to the icon.
 *
 * @output createButtonClick: EventEmitter<string> – Emits the entered name when the create button is clicked.
 */
@Component({
  selector: 'app-empty-state-create',
  templateUrl: './empty-state-create.component.html',
  styleUrls: ['./empty-state-create.component.scss'],
})
export class EmptyStateCreateComponent {
  @Input() isAdmin = false;
  @Input() title: string;
  @Input() description: string;
  @Input() placeholder: string;
  @Input() iconNameAndStyling: string; // icon name in '/assets/svg/optimized/' without full path, add classes after ';'
  @Output() createButtonClick = new EventEmitter<string>();
  inputName: string;
}
